export default{
  aigc_common_search: "Search",
  aigc_common_all: "All",
  aigc_common_expand: "Expand",
  aigc_common_expand_all: "Expand All",
  aigc_common_retract: "Retract",
  aigc_common_other: "Other",
  aigc_common_delete: "Delete",
  aigc_common_delete_success: "Delete successfully",
  aigc_common_delete_fail: 'Delete failed',
  aigc_common_edit: "Edit",

  aigc_common_error_info: "Error, error code {code}",
  aigc_common_confirm: "Confirm",
  aigc_common_cancel: "Cancel",
  aigc_common_release_mouse: "Release Mouse",
  aigc_common_upload_size: "File size:",
  aigc_common_upload_date: "Upload date:",
  aigc_common_upload_cancel: "Cancel upload",
  aigc_common_re_upload: "Re-upload",
  aigc_common_upload_click: "Click to Upload",
  aigc_common_upload_drag: "/Drag to this Area",
  aigc_common_game: 'Game',
  aigc_common_loading: 'Loading...',
  dba_token_monthly_quota: 'Model Usage',
  dba_token_used_label: 'Used',
  dba_token_quota_tip: 'Used {used} / {total} USD this month',
  dba_token_quota_tooltip:
    'This monthly model quota is exclusive to the DataBrain platform and is separate from the company-wide quota. Once the advanced-model usage limit is reached, the system will switch to the standard model to ensure continued service.',
};
